<div class="infringementDetails">
  <div class="main">
    <mat-card>
      <mat-card-header>
        <h2>Infringement #{{ infringement.identifier }}</h2>
      </mat-card-header>
      <mat-card-content>

        <form [formGroup]="infringementDetails" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Accused Name</mat-label>
            <input matInput formControlName="accusedName"/>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Accused URL</mat-label>
            <input matInput formControlName="accusedURL"/>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Accused Country</mat-label>
            <input matInput formControlName="accusedCountry"/>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Accused Address</mat-label>
            <input matInput formControlName="accusedAddress"/>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Accused Email</mat-label>
            <input matInput formControlName="accusedEmail"/>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>External Lawyer</mat-label>
            <input matInput formControlName="externalLawyer"/>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Responsible Employee</mat-label>
            <input matInput formControlName="responsibleEmployee"/>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Further Details</mat-label>
            <input matInput formControlName="infringementDetails"/>
          </mat-form-field>

          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="infringementDetails.pristine">
            Save
          </button>
        </form>
      </mat-card-content>

    </mat-card>
    <div class="double-row">
      <mat-card class="general-comments">
        <mat-card-header>General Comments</mat-card-header>
        <mat-card-content>
          @if (infringement.genericComments) {
            <mat-list>
              <mat-list-item *ngFor="let comment of infringement.genericComments" style="height: initial;">
                <h3 matListItemTitle>{{ comment.date | date:'dd.MM.yyyy' }}</h3>
                <p matListItemLine style="word-wrap: break-word; white-space: pre-wrap;">
                  {{ comment.comment }}
                </p>
              </mat-list-item>
            </mat-list>
          }
          <form [formGroup]="genericComments" (ngSubmit)="onSubmit()">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Comment</mat-label>
              <input matInput formControlName="genericComment"/>
            </mat-form-field>

            <button
              mat-raised-button
              color="primary"
              type="button"
              [disabled]="genericComments.pristine"
              (click)="addComment()">
              Add Comment
            </button>
          </form>

        </mat-card-content>
      </mat-card>
      <mat-card class="debitor">
        <mat-card-header>Debitor</mat-card-header>
        <mat-card-content>
          <p>
            @if (infringement.debitor) {
              <p>Debittor ID: {{ this.infringement.debitor?.ID }}</p>
              <p>invoiceAmmount: {{ this.infringement.debitor?.invoiceAmmount }} €</p>
            } @else {
              No Debitor set!
            }
          </p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>


  <div class="aside">
    <mat-card class="infringement-process">
      <mat-card-header>Status</mat-card-header>
      <mat-card-content>
        <mat-stepper orientation="vertical" [linear]="isLinear" #stepper
                     [selectedIndex]="infringement.infringementStatus">>

          <mat-step [editable]="infringement.infringementStatus == 0" [completed]="infringement.infringementStatus > 0">
            <ng-template matStepLabel>Recorded @if (infringement.dateCreated) {
              <span class="date">{{ infringement.dateCreated | date:'dd.MM.yyyy' }}</span>
            }</ng-template>
            <div>
              <button primary mat-flat-button style="margin-top: 5px;"
                      (click)="openWarningEmailDialog()"
                      [disabled]="isWarningSending">
                {{ isWarningSending ? 'Sending...' : 'Create Warning Email' }}
              </button>
            </div>
          </mat-step>

          <mat-step [editable]="infringement.infringementStatus == 1" [completed]="infringement.infringementStatus > 1">
            <ng-template matStepLabel>Warning Email created @if (infringement.warningSent) {
              <span class="date">{{ infringement.warningSent | date:'dd.MM.yyyy' }}</span>
            }</ng-template>
          </mat-step>

          <mat-step [editable]="infringement.infringementStatus == 2" [completed]="infringement.infringementStatus > 2">
            <ng-template matStepLabel>Response deadline reached @if (infringement.warningDeadline) {
              <span class="date">{{ infringement.warningDeadline | date:'dd.MM.yyyy' }}</span>
            }</ng-template>
            <div>
              <button primary mat-flat-button style="margin-top: 5px;"
                      (click)="openReminderEmailDialog()"
                      [disabled]="isReminderSending">
                {{ isReminderSending ? 'Sending...' : 'Create Reminder Email' }}
              </button>
            </div>
          </mat-step>

          <mat-step [editable]="infringement.infringementStatus == 3" [completed]="infringement.infringementStatus > 3">
            <ng-template matStepLabel>Reminder Email created @if (infringement.reminderDate) {
              <span class="date">{{ infringement.reminderDate | date:'dd.MM.yyyy' }}</span>
            }</ng-template>
          </mat-step>

          <mat-step [editable]="infringement.infringementStatus == 4" [completed]="infringement.infringementStatus > 4">
            <ng-template matStepLabel>Response deadline reached @if (infringement.reminderDeadline) {
              <span class="date">{{ infringement.reminderDeadline | date:'dd.MM.yyyy' }}</span>
            }</ng-template>
            <div style="margin-top: 5px;">
              <button primary mat-flat-button [disabled]="infringement.infringementStatus != 4">Appoint extermal
                Lawfirm
              </button>
              <button primary mat-button [disabled]="infringement.infringementStatus != 4">Close Infringement</button>
            </div>
          </mat-step>

          <mat-step [editable]="infringement.infringementStatus == 5" [completed]="infringement.infringementStatus > 5"
                    [optional]="true">
            <ng-template matStepLabel>External Lawfirm appointed</ng-template>
            <button primary mat-flat-button [disabled]="infringement.infringementStatus != 5" style="margin-top: 5px;">
              Close Infringement
            </button>
          </mat-step>

          <mat-step [editable]="infringement.infringementStatus == 6" [completed]="infringement.infringementStatus > 6">
            <ng-template matStepLabel>Infringement closed @if (infringement.dateClosed) {
              <span class="date">{{ infringement.dateClosed | date:'dd.MM.yyyy' }}</span>
            }</ng-template>
          </mat-step>

        </mat-stepper>
      </mat-card-content>
    </mat-card>

    <mat-card class="it-security">
      <mat-card-header>IT Security Comments</mat-card-header>
      <mat-card-content>
        <mat-checkbox
          class="example-margin"
          [checked]="infringement.itSecurityCheck.checked"
          style="margin-top: 5px;">
          IT Security Check completed
        </mat-checkbox>

        @if (infringement.itSecurityCheck.itSecurityComments && infringement.itSecurityCheck.checked) {
          <p>Comments:</p>
          <mat-list>
            <mat-list-item
              *ngFor="let comment of infringement.itSecurityCheck.itSecurityComments"
            >
              <b>{{ comment.date | date:'dd.MM.yyyy' }}:</b> {{ comment.comment }}
            </mat-list-item>
          </mat-list>
        }
      </mat-card-content>
    </mat-card>

    <mat-card class="attachments">
      <mat-card-header>Attachments</mat-card-header>
      <mat-card-content>
        <div class="attachmentContainer">
          <ul *ngIf="infringement.attachments && infringement.attachments.length > 0" class="attachmentList">
            <li class="existingattachment" *ngFor="let attachment of infringement.attachments"
                (click)="downloadFile(attachment)">
              <span class="file-icon">
                <mat-icon>insert_drive_file</mat-icon>
              </span>
              <span>{{ attachment }}</span>
              <span class="delete-icon" (click)="deleteattachment(attachment); $event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </span>
            </li>
          </ul>
        </div>
        <div class="file-upload-container">
          <!-- Hidden file input -->
          <input
            type="file"
            #fileInput
            (change)="onFileSelected($event)"
            accept="image/*,application/pdf"
            hidden
          />

          <!-- Angular Material button triggers file input -->
          <button mat-raised-button color="primary" (click)="fileInput.click()">
            Upload File
          </button>
        </div>
      </mat-card-content>

    </mat-card>

    <app-matched-mails [identifier]="infringement.identifier"></app-matched-mails>
  </div>
</div>
